import LazyLoadImage from "apps/Common/LazyLoadImage";
import { FC } from "react";
import { Upload, UploadProps } from "antd";
import type { UploadFile } from "antd/es/upload/interface";
import sendImageFramer from "assets/Images/SendImageFrame.svg";

interface ImageUploaderProps {
  fileList: any[];
  setFileList: any

}

const ImageUploader: FC<ImageUploaderProps> = ({ fileList, setFileList}) => {
    const handleChange: UploadProps["onChange"] = ({ fileList }) => {
        setFileList(fileList);
        
      };
    
     

  return (
    <>
     
      <Upload
       className="hover:cursor-pointer"
        fileList={fileList}
        accept=".png,.jpeg,.jpg,.webp,.gif"
        showUploadList={false}
        onChange={handleChange}
        multiple
        beforeUpload={() => false}
      >
        <LazyLoadImage classNames="!w-[25px] !h-[25px] md:!w-[50px] md:!h-[50px]"  wrapperHeight="50px" wrapperWidth="50px" src={sendImageFramer} alt="" />
      </Upload>
    </>
  );
};

export default ImageUploader;
